import BackgroundImage from "./BackgroundImage";

export default class BackgroundImages {

    constructor() {
        this.element = document.querySelector('.background-images');

        this.showNextImage = this.showNextImage.bind(this);

        // For preloading images
        this.imageLoadedHandler = this.imageLoadedHandler.bind(this);
    }

    init() {
        if (this.element) {
            this.setup();
        }
    }

    setup() {
        this.index = 0;
        this.interval = Number(this.element.dataset.interval) || 5000;
        this.images = [...document.querySelectorAll('.custom-image')].map(
            (element, index) => new BackgroundImage({ index, element })
        );

        // Load the first image
        this.images[0].load(this.imageLoadedHandler);

        // if (this.images.length > 1) {
        //     setTimeout(this.showNextImage, this.interval);
        // }
    }

    showNextImage() {
        const nextImage = this.images[this.nextIndex];

        if (nextImage.loaded) {
            this.imageLoadedHandler(nextImage);
        } else {
            nextImage.load(this.imageLoadedHandler);
        }
    }

    imageLoadedHandler(loadedImage) {
        loadedImage.active = true;

        if (loadedImage.index !== this.currentImage.index) {
            this.currentImage.active = false;
        }
        
        this.index = loadedImage.index;

        // Start the timer again
        if (this.images.length > 1) {
            setTimeout(this.showNextImage, this.interval);
        }
    }

    get currentImage() {
        return this.images[this.index];
    }

    get nextIndex() {
        return (this.index + 1 + this.images.length) % this.images.length;
    }
}